import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function criteriaReducer(state = initialState.beoordelingscriteria, action) {
	switch (action.type) {
		case types.CRITERIA_BOVEN_LOKAAL_LOADED: {
			return Object.assign({},
				state,
				{
					item: action.body.item,
					errors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors
				});
		}

		case types.CRITERIA_BOVEN_LOKAAL_SAVED: {
			return Object.assign({},
				state,
				{
					item: action.body.item,
					errors: action.body.errors
				});
		}
		case types.CRITERIA_TOPSPORT_LOADED: {
			return Object.assign({},
				state,
				{
					item: action.body.item,
					errors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors
				});
		}

		case types.CRITERIA_TOPSPORT_SAVED: {
			return Object.assign({},
				state,
				{
					item: action.body.item,
					errors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors
				});
		}

		default:
			return state;
	}
}
